import { createFeatureSelector, createSelector } from '@ngrx/store';
import { JOB_CARD_FEATURE_KEY, JobCardState } from './job-card.reducer';

// Lookup the 'JobCard' feature state managed by NgRx
const getJobCardState =
  createFeatureSelector<JobCardState>(JOB_CARD_FEATURE_KEY);

const getLoaded = createSelector(
  getJobCardState,
  (state: JobCardState) => state.loaded
);
const getError = createSelector(
  getJobCardState,
  (state: JobCardState) => state.error
);

const getAllJobCard = createSelector(
  getJobCardState,
  getLoaded,
  (state: JobCardState, isLoaded) => {
    return isLoaded ? state.list : [];
  }
);
const getSelectedId = createSelector(
  getJobCardState,
  (state: JobCardState) => state.selectedId
);
const getSelectedJobCard = createSelector(
  getAllJobCard,
  getSelectedId,
  (jobCard, id) => {
    const result = jobCard.find((it) => it['id'] === id);
    return result ? Object.assign({}, result) : undefined;
  }
);
const loadSelectedJobCard = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.selectedJobCard
);

const getAllNextJobNo = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.nextJobNo
);

const getLoading = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.loading
);

const getUpdateJobLoading = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.updateJobLoading
);

const getStuffingDetails = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.stuffingDetails
);

const getLoadingConfirmationDetails = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.loadingConfirmationDetails
);

const getTVTBLDetails = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.tvtBLDetails
);

const getEGLBLDetails = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.eglBLDetails
);

const getAWBDetails = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.awbDetails
);
const getLogoUrl = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.logoUrl
);
const getACDDetails = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.acdDetails
);
const getAllFiles = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.files
);
const getLoadFilesLoading = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.loadFilesLoading
);
const getFileProgress = createSelector(
  getJobCardState,
  (state: JobCardState) => state?.fileProgress
);

export const jobCardQuery = {
  getLoaded,
  getError,
  getAllJobCard,
  getSelectedJobCard,
  loadSelectedJobCard,
  getAllNextJobNo,
  getLoading,
  getStuffingDetails,
  getLoadingConfirmationDetails,
  getTVTBLDetails,
  getEGLBLDetails,
  getAWBDetails,
  getLogoUrl,
  getACDDetails,
  getAllFiles,
  getLoadFilesLoading,
  getFileProgress,
  getUpdateJobLoading,
};
